import { render, staticRenderFns } from "./managers-add.vue?vue&type=template&id=7212fc55&"
import script from "./managers-add.vue?vue&type=script&lang=js&"
export * from "./managers-add.vue?vue&type=script&lang=js&"
import style0 from "./managers-add.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports